import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceintalegaonmidc() {



  const cardData =
  {
    keyword: 'Corporate Cab Service in Talegaon MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Talegaon MIDC',
    headingDescription: ' Pune Corporate Cars India Private Limited delivers efficient and reliable Corporate Cab Service in Talegaon MIDC, designed for manufacturing units, industrial companies, logistics firms, and corporate offices operating in the region. Our well-maintained fleet of sedans, SUVs, and staff-transport vehicles ensures smooth daily commuting for employees, managers, and visiting clients. With trained chauffeurs, punctual service, and flexible rental plans, we provide safe and hassle-free transportation tailored to the industrial work environment. Whether your company requires shift-based employee transport, dedicated cabs, outstation corporate travel, or on-demand executive vehicles, Pune Corporate Cars India Private Limited guarantees professional, timely, and high-quality mobility solutions for Talegaon MIDC.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Talegaon Employee Transport",
    "description": "Talegaon Employee Transport provides reliable, timely, and well-coordinated transportation for employees working in the Talegaon MIDC and surrounding industrial zones. Our fleet of AC cars, shuttle vans, and tempo travellers ensures safe and comfortable daily commuting. With verified chauffeurs, GPS-enabled tracking, and optimized routes, Talegaon Employee Transport supports companies in improving punctuality and overall workforce convenience."
  },
  {
    "name": "Talegaon Industrial Area Cab",
    "description": "Talegaon Industrial Area Cab offers structured and dependable cab services for industries and corporate units located in Talegaon MIDC. Ideal for staff movement, executive travel, and inter-factory visits, our AC-equipped vehicles ensure comfort and punctuality. With trained drivers and flexible plans, Talegaon Industrial Area Cab ensures smooth transportation for employees and management teams."
  },
  {
    "name": "MIDC Staff Cab Service",
    "description": "MIDC Staff Cab Service delivers safe and organized transportation for employees working in MIDC zones across Talegaon. Our service includes multi-route travel, fixed shift operations, and scheduled pickups. GPS tracking, clean vehicles, and punctual drivers guarantee a seamless travel experience. MIDC Staff Cab Service is perfect for factories, warehouses, and corporate units with large staff numbers."
  },
  {
    "name": "Talegaon Factory Worker Transport",
    "description": "Talegaon Factory Worker Transport is designed specifically for workers employed in manufacturing plants and industrial units. We provide early-morning, late-evening, and night-shift pickup services with strict safety standards. Vehicles are maintained regularly to ensure reliable travel in heavy industrial zones. Talegaon Factory Worker Transport ensures employees reach their factories safely and on time."
  },
  {
    "name": "Corporate Shuttle Talegaon",
    "description": "Corporate Shuttle Talegaon offers high-capacity transportation for medium and large companies operating in Talegaon MIDC and nearby areas. With AC minibuses, vans, and tempo travellers, we handle large-scale staff movement efficiently. Our service is ideal for shift operations, multi-route planning, and organized daily commuting. Corporate Shuttle Talegaon ensures safe, economical, and smooth corporate travel."
  },
  {
    "name": "Staff Pick & Drop Talegaon",
    "description": "Staff Pick & Drop Talegaon ensures convenient, punctual, and well-managed staff transportation for companies in Talegaon. We offer multiple pickup points, optimized routes, and on-time drop-offs. All vehicles are monitored and driven by trained professionals. Staff Pick & Drop Talegaon helps companies streamline employee commuting and enhance workforce reliability."
  },
  {
    "name": "Company Cab Service Talegaon",
    "description": "Company Cab Service Talegaon provides professional cab solutions for corporate offices, factories, and industrial units. Whether for executive travel, office commute, client visits, or field operations, our AC vehicles and trained chauffeurs deliver consistent service quality. Company Cab Service Talegaon ensures smooth and dependable corporate mobility every day."
  },
  {
    "name": "Best Corporate Cabs Talegaon",
    "description": "Best Corporate Cabs Talegaon offers top-rated travel services with clean, comfortable sedans and SUVs ideal for corporate teams. Known for punctuality and safety, our service supports daily office travel, executive movement, and industrial visits. Companies can choose from daily bookings, monthly contracts, or on-demand travel. Best Corporate Cabs Talegaon ensures a premium, reliable travel experience."
  },
  {
    "name": "Affordable Office Cabs Talegaon",
    "description": "Affordable Office Cabs Talegaon provides cost-effective transportation solutions for businesses and factories in the Talegaon region. Despite being budget-friendly, all vehicles are maintained, sanitized, and equipped with AC for comfort. This service is ideal for startups, mid-sized companies, and industrial units looking for economical daily commute options. Affordable Office Cabs Talegaon combines efficiency with affordability."
  },
  {
    "name": "Talegaon Monthly Cab Hire",
    "description": "Talegaon Monthly Cab Hire offers long-term mobility solutions with dedicated vehicles assigned to your company. This plan includes predictable billing, trained chauffeurs, priority replacements, and uninterrupted service. Ideal for executives, field staff, and daily commute requirements. Talegaon Monthly Cab Hire ensures consistent and professional transportation throughout the month."
  },
  {
    "name": "Talegaon Business Travel Cabs",
    "description": "Talegaon Business Travel Cabs provides premium and reliable cab services for business meetings, corporate visits, airport transfers, and industrial tours. Our vehicles feature AC, clean interiors, and trained chauffeurs to ensure a smooth and professional travel experience. Talegaon Business Travel Cabs is ideal for companies requiring high-standard business mobility."
  },
  {
    "name": "Outstation Cab Talegaon",
    "description": "Outstation Cab Talegaon offers safe and comfortable intercity travel for corporate meetings, site visits, and long-distance business travel. Our sedans and SUVs provide seamless travel to destinations like Pune, Nashik, Aurangabad, Kolhapur, and Mumbai. With experienced chauffeurs and well-maintained vehicles, Outstation Cab Talegaon ensures timely and comfortable outstation journeys."
  },
  {
    "name": "Employee Commute Talegaon",
    "description": "Employee Commute Talegaon delivers structured, safe, and reliable commuting solutions for small and large teams. Our service includes daily pickups, fixed drop schedules, verified drivers, and real-time tracking. Designed for companies in MIDC zones, Employee Commute Talegaon ensures employees reach work comfortably and efficiently every day."
  },
  {
    "name": "Corporate Fleet Talegaon",
    "description": "Corporate Fleet Talegaon provides companies with complete fleet management solutions including sedans, SUVs, vans, and tempo travellers. We manage driver allocation, maintenance, fuel, replacements, and scheduling. Ideal for industries, IT parks, and corporate campuses, Corporate Fleet Talegaon ensures centralized and hassle-free mobility operations."
  },
  {
    "name": "Office Transport Talegaon",
    "description": "Office Transport Talegaon delivers dependable office commute services with fixed timings, professional drivers, and comfortable AC vehicles. Designed for companies with daily employee movement, this service ensures punctual arrivals, safe travel, and smooth routing. Office Transport Talegaon supports companies in maintaining efficient workforce mobility."
  }
],
"tableData": [
  ["Talegaon Employee Transport", "Talegaon Industrial Area Cab"],
  ["MIDC Staff Cab Service", "Talegaon Factory Worker Transport"],
  ["Corporate Shuttle Talegaon", "Staff Pick & Drop Talegaon"],
  ["Company Cab Service Talegaon", "Best Corporate Cabs Talegaon"],
  ["Affordable Office Cabs Talegaon", "Talegaon Monthly Cab Hire"],
  ["Talegaon Business Travel Cabs", "Outstation Cab Talegaon"],
  ["Employee Commute Talegaon", "Corporate Fleet Talegaon"],
  ["Office Transport Talegaon", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Talegaon MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides dependable and professional corporate cab services in Talegaon MIDC, ensuring smooth and timely transportation for employees and executives."
  },
  {
    "WhyChooseheading": "Ideal for Industrial & Manufacturing Companies",
    "WhyChoosedescription": "Our services are tailored for companies located in Talegaon MIDC, offering reliable transportation for shift workers and corporate staff."
  },
  {
    "WhyChooseheading": "Safe, Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs undergo regular servicing and sanitization to ensure clean, safe, and comfortable rides for daily corporate travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Pricing",
    "WhyChoosedescription": "We provide clear and budget-friendly pricing with no hidden costs, suitable for small teams, large organizations, and long-term contracts."
  },
  {
    "WhyChooseheading": "Flexible Pick-Up & Drop Schedules",
    "WhyChoosedescription": "Choose from customized pickup and drop timings designed to match factory shifts, office hours, and employee schedules."
  },
  {
    "WhyChooseheading": "Experienced & Professional Drivers",
    "WhyChoosedescription": "Our trained chauffeurs ensure punctuality, safe driving, and a smooth travel experience for all corporate passengers."
  },
  {
    "WhyChooseheading": "24/7 Corporate Support",
    "WhyChoosedescription": "We offer round-the-clock assistance for bookings, schedule adjustments, and urgent travel requirements for Talegaon MIDC companies."
  },
  {
    "WhyChooseheading": "Quick & Hassle-Free Booking",
    "WhyChoosedescription": "Book your corporate cab for Talegaon MIDC easily via our online system or phone, with fast confirmations and dependable service."
  }
]






















  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate cab services in Talegaon MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and professional corporate cab services in Talegaon MIDC for employee transportation, meetings, and industrial visits.',
  },
  {
    question: 'How can I book a corporate cab in Talegaon MIDC with Pune Corporate Cars India Private Limited?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Talegaon MIDC?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and premium cars suitable for corporate and industrial travel needs.',
  },
  {
    question: 'Are the drivers trained for corporate and industrial routes in Talegaon MIDC?',
    answer: 'Yes, our drivers are professionally trained, punctual, and well-versed with Talegaon MIDC routes and shift timings.',
  },
  {
    question: 'Do you offer daily, weekly, or monthly corporate cab packages in Talegaon MIDC?',
    answer: 'Absolutely. We offer flexible cab plans including daily, weekly, and monthly packages for companies in Talegaon MIDC.',
  },
  {
    question: 'Is the corporate cab service available 24×7 in Talegaon MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides round-the-clock availability to support all shift schedules and corporate travel needs.',
  },
  {
    question: 'What safety and hygiene protocols are followed for corporate cabs in Talegaon MIDC?',
    answer: 'All vehicles are sanitized regularly and drivers follow strict hygiene and safety guidelines to ensure a safe commute.',
  },
  {
    question: 'What payment options are available for corporate cab services in Talegaon MIDC?',
    answer: 'We accept UPI, credit/debit cards, net banking, digital wallets, and corporate billing options.',
  },
  {
    question: 'Is customer support available during the corporate cab service period?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you throughout the service duration.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Abhijit Patil',
    feedback: 'Excellent corporate cab service in Talegaon MIDC. The driver was punctual and the ride was smooth. Perfect for industrial travel.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Khare',
    feedback: 'Our company regularly uses Pune Corporate Cars India Private Limited in Talegaon MIDC. Very dependable and professional service.',
    rating: 5,
  },
];











































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Talegaon MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-talegaon.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Talegaon MIDC, Pune, providing employee transport, office pickup and drop, factory and industrial area commute, and business travel cabs. Pune Corporate Cars India Private Limited offers chauffeur-driven sedans, SUVs, and outstation cabs for corporate clients in Talegaon.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4500", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-talegaon-midc"
  }
};







  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Talegaon MIDC | Employee & Office Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Talegaon MIDC, Pune, providing employee transport, office pickup and drop, factory and industrial area commute, and business travel cabs. Pune Corporate Cars India Private Limited offers chauffeur-driven sedans, SUVs, and outstation cabs for corporate clients in Talegaon."
  />

  <meta
    name="keywords"
    content="Talegaon Employee Transport, Talegaon Industrial Area Cab, MIDC Staff Cab Service, Talegaon Factory Worker Transport, Corporate Shuttle Talegaon, Staff Pick & Drop Talegaon, Company Cab Service Talegaon, Best Corporate Cabs Talegaon, Affordable Office Cabs Talegaon, Talegaon Monthly Cab Hire, Talegaon Business Travel Cabs, Outstation Cab Talegaon, Employee Commute Talegaon, Corporate Fleet Talegaon, Office Transport Talegaon"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceintalegaonmidc;